import React from "react";
import styles from "../styles/vinos.module.css";
import { FaMagnifyingGlass } from "react-icons/fa6";
import VinoItem from "./VinoItem";

export default function VinosList({
    list,
    isOpen,
    onToggle,
    selection,
    onToggleStage,
    onEdit,
    onDelete,
}) {
    return (
        <section className={styles.section}>
            <div className={styles.stack}>
                {list.length === 0 ? (
                    <div className={`${styles.card} ${styles.soft} ${styles.empty}`}>
                        <h4 style={{ margin: 0 }}><FaMagnifyingGlass style={{ fontSize: "30px" }} /></h4>
                        <p className={styles.muted}>Prueba con otro término de búsqueda o crea un vino.</p>
                    </div>
                ) : (
                    list.map((v) => (
                        <VinoItem
                            key={v.id}
                            vino={v}
                            open={isOpen(v.id)}
                            onToggle={() => onToggle(v.id)}
                            selection={selection}
                            onToggleStage={onToggleStage}
                            onEdit={() => onEdit(v)}
                            onDelete={() => onDelete(v.id)}
                        />
                    ))
                )}
            </div>
        </section>
    );
}
